import nodeahder from '@/layout/no-header'

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 用户路由
export default
[
  {
    path: '/sagerui',
    name: '赛格锐',
    component: nodeahder,
    meta: {
      title: '赛格锐',
      auth: true
    },
    // redirect: { name: 'index' },
    children: [
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '赛格锐',
          auth: true
        },
        component: _import('sagerui/page')
      },
      // 赛事管理
      {
        path: 'match',
        name: 'match',
        meta: {
          title: '赛事管理',
          auth: true
        },
        component: _import('sagerui/match/index.vue')
      },
      {
        path: 'equipment',
        name: 'Equipment',
        meta: {
          title: '设备管理',
          auth: true
        },
        component: _import('sagerui/equipment')
      },
      {
        path: 'setting',
        name: 'setting',
        meta: {
          title: '公棚设置',
          auth: true
        },
        component: _import('sagerui/setting/setting')
      }

    ]

  }
]
